import {SODeleteCertificate} from '../../core/certificate/so-delete-certificate';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteCertificate extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteCertificate;
}